export const OfficeWithTreesNoBg: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => (
  <svg
    width={133.579}
    height={133.579}
    viewBox="0 0 133.579 133.579"
    xmlns="http://www.w3.org/2000/svg"
    role="none"
    {...props}
  >
    <g>
      <path
        d="m117.632,105.756c0-.03.005-.06.005-.09,0-3.131-2.538-5.668-5.668-5.668-.646,0-1.264.113-1.843.312-.714-.655-1.593-1.129-2.571-1.35.493-.841.781-1.816.781-2.861,0-3.131-2.538-5.668-5.668-5.668h-11.082v22.987h21.936c.783.679,1.795,1.1,2.912,1.1,2.466,0,4.464-1.999,4.464-4.464,0-2.049-1.383-3.772-3.265-4.297Z"
        fill="#00a49f"
      />
      <path
        d="m38.488,112.513v-11.102c.679-.783,1.1-1.795,1.1-2.912,0-2.466-1.999-4.464-4.464-4.464-2.049,0-3.772,1.383-4.297,3.265-.03,0-.06-.005-.09-.005-3.131,0-5.668,2.538-5.668,5.668,0,.646.113,1.264.312,1.843-.655.714-1.129,1.593-1.35,2.571-.841-.493-1.816-.781-2.861-.781-3.131,0-5.668,2.538-5.668,5.668v.249h22.987Z"
        fill="#00a49f"
      />
      <g>
        <rect x="27.545" y="45.054" width="40.648" height="66.359" fill="#1d3c81" />
        <rect x="31.388" y="50.212" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="58.545" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="66.879" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="75.213" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="83.547" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="91.881" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="50.212" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="58.545" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="66.879" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="75.213" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="83.547" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="91.881" width="32.961" height="5.669" fill="#c7dcff" />
        <rect x="31.388" y="99.919" width="5.669" height="5.669" fill="#c7dcff" />
        <rect x="39.152" y="99.919" width="5.669" height="5.669" fill="#c7dcff" />
        <rect x="46.915" y="99.919" width="5.669" height="5.669" fill="#c7dcff" />
        <rect x="54.436" y="99.919" width="5.669" height="5.669" fill="#3a77ff" />
        <polygon
          points="69.666 97.55 69.666 91.881 51.856 91.881 50.648 97.55 69.666 97.55"
          fill="#3a77ff"
        />
        <polygon
          points="55.407 75.213 54.199 80.882 69.666 80.882 69.666 75.213 55.407 75.213"
          fill="#3a77ff"
        />
        <polygon
          points="53.631 83.547 52.423 89.216 69.666 89.216 69.666 83.547 53.631 83.547"
          fill="#3a77ff"
        />
        <polygon
          points="52.585 105.588 52.585 99.919 50.143 99.919 48.935 105.588 52.585 105.588"
          fill="#3a77ff"
        />
        <polygon
          points="60.742 50.17 59.525 55.881 69.666 55.881 69.666 50.17 60.742 50.17"
          fill="#3a77ff"
        />
        <polygon
          points="58.958 58.545 57.75 64.215 69.666 64.215 69.666 58.545 58.958 58.545"
          fill="#3a77ff"
        />
        <polygon
          points="57.182 66.879 55.974 72.549 69.666 72.549 69.666 66.879 57.182 66.879"
          fill="#3a77ff"
        />
      </g>
      <rect x="5.356" y="110.755" width="122.866" height="3.862" fill="#1d3c81" />
      <g>
        <rect x="58.68" y="27.333" width="43.987" height="84.08" fill="#1d3c81" />
        <rect x="62.523" y="33.544" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="41.878" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="50.212" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="58.545" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="66.879" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="75.213" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="83.547" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="91.881" width="36.301" height="5.669" fill="#c7dcff" />
        <rect x="62.523" y="99.919" width="5.669" height="5.669" fill="#c7dcff" />
        <rect x="93.155" y="99.919" width="5.669" height="5.669" fill="#3a77ff" />
        <rect x="71.471" y="99.919" width="18.404" height="11.494" fill="#c7dcff" />
        <polygon
          points="85.74 66.921 84.559 72.532 98.824 72.532 98.824 66.921 85.74 66.921"
          fill="#3a77ff"
        />
        <polygon
          points="98.824 97.55 98.824 91.964 80.472 91.964 79.298 97.55 98.824 97.55"
          fill="#3a77ff"
        />
        <polygon
          points="83.981 75.28 82.803 80.882 98.824 80.882 98.824 75.28 83.981 75.28"
          fill="#3a77ff"
        />
        <polygon
          points="98.824 39.13 98.824 33.544 92.759 33.544 91.585 39.13 98.824 39.13"
          fill="#3a77ff"
        />
        <polygon
          points="82.225 83.631 81.05 89.216 98.824 89.216 98.824 83.631 82.225 83.631"
          fill="#3a77ff"
        />
        <polygon
          points="87.483 58.629 86.318 64.173 98.824 64.173 98.824 58.629 87.483 58.629"
          fill="#3a77ff"
        />
        <polygon
          points="71.471 99.919 71.471 111.413 76.382 111.413 78.8 99.919 71.471 99.919"
          fill="#c7dcff"
        />
        <polygon
          points="89.876 99.919 78.8 99.919 76.382 111.413 89.876 111.413 89.876 99.919"
          fill="#3a77ff"
        />
        <polygon
          points="91.007 41.878 89.823 47.505 98.824 47.505 98.824 41.878 91.007 41.878"
          fill="#3a77ff"
        />
        <polygon
          points="89.245 50.254 88.061 55.881 98.824 55.881 98.824 50.254 89.245 50.254"
          fill="#3a77ff"
        />
      </g>
      <path
        d="m41.748,28.505c.001-.068.01-.134.01-.202,0-5.159-4.182-9.341-9.341-9.341-4.669,0-8.526,3.429-9.219,7.904-.041,0-.081-.006-.122-.006-5.159,0-9.341,4.182-9.341,9.341h35.304c-.596-3.838-3.523-6.903-7.292-7.696Z"
        fill="#fff"
      />
    </g>
  </svg>
);
